// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    padding: 0;
    margin: 0;
}

.style__loading___BYTCv {
    z-index: 100;
    background: linear-gradient(to right, red, #6060FF);
    height: 3px;
    position: absolute;
}

@media screen and (min-width: 1100px) {
    .style__iphone___XjcNC {
        height: 90vh;
        width: 50vh;
        position: absolute;
        right: 37vh;
        z-index: 1;
        bottom: 8vh;
    }

    .style__android___i6vVF {
         bottom: 5vh;
        height: 85vh;
        width: 45vh;
        position: absolute;
        right: 10vh;
    }

    .style__blackScreen___ntye3 {
        display: none;
    }
}

@media screen and (max-width: 1100px) {
    .style__desktop___DPtp3 {
        display: none;
    }

    .style__iphone___XjcNC {
        height: 55vh;
        width: 33vh;
        position: absolute;
        left: -8vw;
        top: 50vh;
        z-index: 1;
    }

    .style__android___i6vVF {
        height: 53vh;
        width: 32vh;
        position: absolute;
        left: 32vw;
        top: 53vh;
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/style.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,mDAAmD;IACnD,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,WAAW;IACf;;IAEA;SACK,WAAW;QACZ,YAAY;QACZ,WAAW;QACX,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,SAAS;IACb;AACJ","sourcesContent":["* {\n    padding: 0;\n    margin: 0;\n}\n\n.loading {\n    z-index: 100;\n    background: linear-gradient(to right, red, #6060FF);\n    height: 3px;\n    position: absolute;\n}\n\n@media screen and (min-width: 1100px) {\n    .iphone {\n        height: 90vh;\n        width: 50vh;\n        position: absolute;\n        right: 37vh;\n        z-index: 1;\n        bottom: 8vh;\n    }\n\n    .android {\n         bottom: 5vh;\n        height: 85vh;\n        width: 45vh;\n        position: absolute;\n        right: 10vh;\n    }\n\n    .blackScreen {\n        display: none;\n    }\n}\n\n@media screen and (max-width: 1100px) {\n    .desktop {\n        display: none;\n    }\n\n    .iphone {\n        height: 55vh;\n        width: 33vh;\n        position: absolute;\n        left: -8vw;\n        top: 50vh;\n        z-index: 1;\n    }\n\n    .android {\n        height: 53vh;\n        width: 32vh;\n        position: absolute;\n        left: 32vw;\n        top: 53vh;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": `style__loading___BYTCv`,
	"iphone": `style__iphone___XjcNC`,
	"android": `style__android___i6vVF`,
	"blackScreen": `style__blackScreen___ntye3`,
	"desktop": `style__desktop___DPtp3`
};
export default ___CSS_LOADER_EXPORT___;
